import React from 'react';
import { STAND_ALONE_RESULTS_EDIT } from './const';
import AppWrapper from '../../../components/AppWrapper';
import { UserNotice } from '../../../components';
import { ResultMainForm, ResultSideMenu } from '../components';
import { useEditStandAloneResult } from './useEditStandAloneResult';
import { HeroBanner } from '../../../components/ProjectForm/components';
import * as Styled from './styles';

const EditStandAloneResult = () => {
  const hook = useEditStandAloneResult();

  return (
    <AppWrapper>
      <HeroBanner
        generalInfo={STAND_ALONE_RESULTS_EDIT.HEADER}
        handleNavigate={hook.handleNavigate}
        heroInfo={{
          type: 'standAloneResult',
          title: hook.resultInfo?.title,
          bottomSubtitle: hook.resultInfo?.nick_name,
        }}
        projectPath={`/result/standalone/${hook.resultInfo?.id}`}
      />
      <UserNotice
        title={STAND_ALONE_RESULTS_EDIT.HEADER.title}
        description={STAND_ALONE_RESULTS_EDIT.INFO_BOX.DESCRIPTION}
        link={STAND_ALONE_RESULTS_EDIT.INFO_BOX.LINK}
        secondaryLink={STAND_ALONE_RESULTS_EDIT.INFO_BOX.SECONDARY_LINK}
      />

      <Styled.SpiltSectionStyled>
        <ResultMainForm
          resultInfo={hook.resultInfo}
          addInputHandler={hook.addInputHandler}
          teamMembers={hook.teamMembers}
          updateResultInfoHandler={hook.updateResultInfoHandler}
          changeAddedInputHandler={hook.changeAddedInputHandler}
          removeInputHandler={hook.removeInputHandler}
          collaboratingOrganizations={hook.collaboratingOrganizations}
          selectedRegionalCenters={hook.selectedRegionalCenters}
          categoriesMap={hook.healthCategories}
          setHealthCategoriesHandler={hook.setHealthCategoriesHandler}
          selectedHealthCategories={hook.selectedHealthCategories}
          forceChange={hook.forceChange}
          healthAuthorityRegions={hook.healthAuthorityRegions}
          checkboxInputHandler={hook.checkboxInputHandler}
          selectedHealthAuthorityRegions={hook.selectedHealthAuthorityRegions}
          fileHandler={hook.fileHandler}
          removeFileHandler={hook.removeFileHandler}
          currentFile={hook.resourceFile}
          checkForReseacherAccount={hook.checkForReseacherAccount}
          hospitals={hook.hospitals}
          errors={hook.errors}
        />
        <Styled.StickyDivStyled>
          <ResultSideMenu
            status={hook.resultInfo.status}
            submitHandler={hook.submitHandler}
            isSubmitting={hook.isSubmiting}
            errors={hook.errors}
          />
        </Styled.StickyDivStyled>
      </Styled.SpiltSectionStyled>
    </AppWrapper>
  );
};

export default EditStandAloneResult;
